import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 53;

export const migration_52_53:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                    Object.values(page.artboard.allBoxes).map((boxSnapshot:any) =>
                    {
                        const {component, componentDesc} = boxSnapshot;

                        if( component.name === 'TextInput' )
                        {
                            Object.values(componentDesc._properties).forEach((property:any) =>
                            {
                                if( property.name === 'model' )
                                {
                                    property._value = {
                                        ...property._value,
                                        placeholder: {
                                            text: property._value.placeholder,
                                            visibility: {
                                                '__type': 'BOOLEAN',
                                                'value': true
                                            },
                                            font: {
                                                'typeface': {
                                                    '__type': 'STRINGENUM',
                                                    'selectedValue': 'Helvetica Neue',
                                                    'values': [
                                                        'Arial',
                                                        'Verdana',
                                                        'Times New Roman',
                                                        'Helvetica Neue'
                                                    ]
                                                },
                                                'weight': {
                                                    '__type': 'STRINGENUM',
                                                    'selectedValue': 'Regular',
                                                    'values': [
                                                        'Thin',
                                                        'Light',
                                                        'Regular',
                                                        'Medium',
                                                        'Bold'
                                                    ]
                                                },
                                                'color': {
                                                    'hex': {
                                                        '__type': 'STRING',
                                                        'value': '#757575'
                                                    },
                                                    'alpha': {
                                                        '__type': 'NUMBER',
                                                        'value': 1
                                                    }
                                                },
                                                'size': {
                                                    'value': {
                                                        '__type': 'NUMBER',
                                                        'value': 16
                                                    },
                                                    'unitsType': {
                                                        '__type': 'STRINGENUM',
                                                        'selectedValue': 'px',
                                                        'values': [
                                                            'px',
                                                            '%',
                                                            'auto'
                                                        ]
                                                    }
                                                },
                                                'lineHeight': {
                                                    'value': {
                                                        '__type': 'NUMBER',
                                                        'value': 18
                                                    },
                                                    'unitsType': {
                                                        '__type': 'STRINGENUM',
                                                        'selectedValue': 'px',
                                                        'values': [
                                                            'px',
                                                            '%',
                                                            'auto'
                                                        ]
                                                    }
                                                },
                                                'character': {
                                                    'value': {
                                                        '__type': 'NUMBER',
                                                        'value': 1
                                                    },
                                                    'unitsType': {
                                                        '__type': 'STRINGENUM',
                                                        'selectedValue': 'px',
                                                        'values': [
                                                            'px',
                                                            '%',
                                                            'auto'
                                                        ]
                                                    }
                                                },
                                                'fontStyle': {
                                                    '__type': 'BOOLEAN',
                                                    'value': false
                                                },
                                                'decorationUnderline': {
                                                    '__type': 'BOOLEAN',
                                                    'value': false
                                                },
                                                'decorationCrossed': {
                                                    '__type': 'BOOLEAN',
                                                    'value': false
                                                }
                                            }
                                        },
                                        'isFormatEnabled': {
                                            '__type': 'BOOLEAN',
                                            'value': false
                                        },
                                        'format': {
                                            '__type': 'STRING',
                                            'value': ''
                                        },
                                        'isRegExp': {
                                            '__type': 'BOOLEAN',
                                            'value': false
                                        },
                                        'fractionDigits': {
                                            '__type': 'INTEGER',
                                            'value': 2
                                        },
                                        'isAllowAnyCharacter': {
                                            '__type': 'BOOLEAN',
                                            'value': false
                                        },
                                        'textTransform': {
                                            '__type': 'STRINGENUM',
                                            'selectedValue': 'None',
                                            'values': [
                                                'None',
                                                'Uppercase',
                                                'Lowercase',
                                                'Camelcase'
                                            ]
                                        },
                                        'isApplyFormatToValue': {
                                            '__type': 'BOOLEAN',
                                            'value': false
                                        },
                                        'isUseGuidance': {
                                            '__type': 'BOOLEAN',
                                            'value': false
                                        },
                                        'guidancePattern': {
                                            '__type': 'STRING',
                                            'value': 'x'
                                        },
                                        'prefix': {
                                            '__type': 'STRING',
                                            'value': ''
                                        },
                                        'suffix': {
                                            '__type': 'STRING',
                                            'value': ''
                                        },
                                        'isGlueToUserInput': {
                                            '__type': 'BOOLEAN',
                                            'value': false
                                        },
                                        prefixSuffixFont: {
                                            'typeface': {
                                                '__type': 'STRINGENUM',
                                                'selectedValue': 'Helvetica Neue',
                                                'values': [
                                                    'Arial',
                                                    'Verdana',
                                                    'Times New Roman',
                                                    'Helvetica Neue'
                                                ]
                                            },
                                            'weight': {
                                                '__type': 'STRINGENUM',
                                                'selectedValue': 'Regular',
                                                'values': [
                                                    'Thin',
                                                    'Light',
                                                    'Regular',
                                                    'Medium',
                                                    'Bold'
                                                ]
                                            },
                                            'color': {
                                                'hex': {
                                                    '__type': 'STRING',
                                                    'value': '#757575'
                                                },
                                                'alpha': {
                                                    '__type': 'NUMBER',
                                                    'value': 1
                                                }
                                            },
                                            'size': {
                                                'value': {
                                                    '__type': 'NUMBER',
                                                    'value': 16
                                                },
                                                'unitsType': {
                                                    '__type': 'STRINGENUM',
                                                    'selectedValue': 'px',
                                                    'values': [
                                                        'px',
                                                        '%',
                                                        'auto'
                                                    ]
                                                }
                                            },
                                            'lineHeight': {
                                                'value': {
                                                    '__type': 'NUMBER',
                                                    'value': 18
                                                },
                                                'unitsType': {
                                                    '__type': 'STRINGENUM',
                                                    'selectedValue': 'px',
                                                    'values': [
                                                        'px',
                                                        '%',
                                                        'auto'
                                                    ]
                                                }
                                            },
                                            'character': {
                                                'value': {
                                                    '__type': 'NUMBER',
                                                    'value': 1
                                                },
                                                'unitsType': {
                                                    '__type': 'STRINGENUM',
                                                    'selectedValue': 'px',
                                                    'values': [
                                                        'px',
                                                        '%',
                                                        'auto'
                                                    ]
                                                }
                                            },
                                            'fontStyle': {
                                                '__type': 'BOOLEAN',
                                                'value': false
                                            },
                                            'decorationUnderline': {
                                                '__type': 'BOOLEAN',
                                                'value': false
                                            },
                                            'decorationCrossed': {
                                                '__type': 'BOOLEAN',
                                                'value': false
                                            }
                                        },
                                        'isRtl': {
                                            '__type': 'BOOLEAN',
                                            'value': false
                                        },
                                        'isValidationEnabled': {
                                            '__type': 'BOOLEAN',
                                            'value': false
                                        },
                                        'isMatchesFormat': {
                                            '__type': 'BOOLEAN',
                                            'value': false
                                        },
                                        'isRequired': {
                                            '__type': 'BOOLEAN',
                                            'value': false
                                        },
                                        'isMatchesFormatStatus': {
                                            '__type': 'BOOLEAN',
                                            'value': true
                                        },
                                        'isRequiredStatus': {
                                            '__type': 'BOOLEAN',
                                            'value': true
                                        },
                                        'isValid': {
                                            '__type': 'BOOLEAN',
                                            'value': true
                                        },
                                    };
                                }
                            });
                        }
                    });
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
